import React from "react";

import type { NapiUser } from "@app/types/napi-types";

import { AccountLink } from "./account-link";
import { SignInLink } from "./signin-button";

interface Props {
  user?: NapiUser;
}

export const AccountItem: React.FC<Props> = ({ user }) => {
  return user ? <AccountLink /> : <SignInLink />;
};
